import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';
import { TabsContent } from '@/components/ui/tabs';

import { TabProps } from '../tabConfig';
import { LookupTable } from './table';

export function LookupsTab({ importTypeId, importTypeName }: TabProps) {
	return (
		<TabsContent value="lookups">
			<Card>
				<CardHeader>
					<CardTitle>Lookups</CardTitle>
					<CardDescription>Lookup Mappings for {importTypeName}</CardDescription>
				</CardHeader>
				<CardContent className="space-y-2">
					<LookupTable importTypeId={importTypeId} />
				</CardContent>
			</Card>
		</TabsContent>
	);
}
